// extracted by mini-css-extract-plugin
export default {"container":"Lm-z","bubbleNav":"Mm-z","graphic":"Nm-z","contact":"Om-z"};